<template>

<!-- Modal -->
<div class="modal" id="filterModal" data-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header bg-info text-white">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fas fa-filter mr-2"></i>
          FILTRA COLONNE</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ul id="example-1">
          <li v-for="(item,index) in header" :key="index">           
            <div class="form-group form-check">
                 <input type="checkbox" class="form-check-input" :id="'exampleCheck1_' + index" v-model="item.selected">
                <label class="form-check-label" :for="'exampleCheck1_' + index">{{item.col}}</label>
            </div>


          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <!--<button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>-->
        <button type="button" @click="$emit('update',header)" data-dismiss="modal" class="btn btn-primary ">APPLICA FILTRO</button>
      </div>
    </div>
  </div>
</div>





</template>
<script>


export default {
   props : ['header'],
  components: {},
  data() {
    return {
    
     col : []
    
      
    };
  },
   
  methods: 
  {
  }  
    
   

}
</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 18px;  
}
small {
  font-family  : 'Roboto Condensed';
  font-size    : 15px;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;

}
/*
.modal-footer {  
  justify-content: space-between;  
}
*/
.form-check-label
{
      cursor : pointer; 
}

   
</style>


